export default "__VITE_ASSET__CggeYSTA__"